import { render, staticRenderFns } from "./callNotificationItem.vue?vue&type=template&id=28c35cf4"
import script from "./callNotificationItem.vue?vue&type=script&lang=ts"
export * from "./callNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports